import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import getMediaElement from 'editor/src/store/design/selector/getMediaElement';
import { updateMediaElementAction } from 'editor/src/store/design/slice';
import { ElementAddress, MediaImage } from 'editor/src/store/design/types';
import saveUndoRedoStateOperation from 'editor/src/store/editorModules/undoRedo/operation/saveUndoRedoStateOperation';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';

import calculateCurrentCropZoomScale from 'editor/src/util/design/crop/calculateCurrentCropZoomScale';
import { CROP_ZOOM_STEP, MAX_CROP_ZOOM_LEVEL } from 'editor/src/util/design/crop/constants';
import getCropZoomScale from 'editor/src/util/design/crop/getCropZoomScale';

const imageCropZoomInOperation =
  (elementAddress: ElementAddress) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const image = getMediaElement<MediaImage>(state, elementAddress);
    if (!image) {
      return;
    }
    const currentZoomScale = calculateCurrentCropZoomScale(image);
    if (currentZoomScale >= MAX_CROP_ZOOM_LEVEL) {
      return;
    }
    const newZoomScale = Math.min(MAX_CROP_ZOOM_LEVEL, currentZoomScale + CROP_ZOOM_STEP);

    batch(() => {
      dispatch(saveUndoRedoStateOperation('Zoom in'));
      dispatch(
        updateMediaElementAction({
          elementAddress,
          elementUpdate: getCropZoomScale(image, newZoomScale),
        }),
      );
    });
  };

export default imageCropZoomInOperation;
